$(document).ready(function () {

    "use strict";

    $('.js_offerImageSlider').slick({
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-arrow slick-prev"><img src="/sites/petervardy/images/svgs/angle-left-regular.svg" alt="Previous Arrow" /></i></button>',
        nextArrow: '<button type="button" class="slick-arrow slick-next"><img src="/sites/petervardy/images/svgs/angle-right-regular.svg" alt="Next Arrow" /></button>',
    });

}); // document ready
